// Детали конфликта команды таблицы — параметры 409 REC-001 (011: contracts/api.md,
// ConflictDetails; ADR-0032). Правки разных полей сливаются; конфликт — поле, которое изменил
// другой после базовой ревизии, или дерево при устаревшей ревизии дерева.
import { z } from '../kernel/zod.ts';
import { IdSchema, PersonRefSchema, TimestampSchema } from '../kernel/common.ts';
import { ITEM_FIELD_KEY_PATTERN, ItemFieldSchema } from './item.ts';

/**
 * Поле конфликта (013: research, Р15): поле пункта, оформление поля (`style.<поле>`) или признак
 * «скрыто в протоколе» (`hidden`). Значения оформления — JSON `CellStyle`, признака — `true`/`false`.
 */
export const ConflictFieldSchema = z.union([
  ItemFieldSchema,
  z.string().regex(new RegExp(`^style\\.${ITEM_FIELD_KEY_PATTERN.source.slice(1, -1)}$`)),
  // Роль ячейки в объединении (017: research, Р2) — своя база, как у оформления.
  z.string().regex(new RegExp(`^merge\\.${ITEM_FIELD_KEY_PATTERN.source.slice(1, -1)}$`)),
  z.literal('hidden'),
  z.literal('progress'),
  // Переносы срока (014: research, Р3) — отдельное событие рядом с `dueRaw`.
  z.literal('dueTransfers'),
]);

export const CommandConflictSchema = z.object({
  itemId: IdSchema,
  /** Поле; null — конфликт дерева. */
  field: ConflictFieldSchema.nullable(),
  structure: z.boolean(),
  /** Значение на базовой ревизии команды, текущее значение и пришедшее (null — у дерева). */
  base: z.string().nullable(),
  current: z.string().nullable(),
  incoming: z.string().nullable(),
  changedBy: PersonRefSchema,
  changedAt: TimestampSchema,
  /**
   * Текст для показа в окне конфликта (015: research, Р8) у ответственных (имена через «; »)
   * и состояния (подпись и пояснение); у остальных полей — null. Необязательные: подменные
   * серверы 011–014 их не отдают.
   */
  baseDisplay: z.string().nullable().optional(),
  currentDisplay: z.string().nullable().optional(),
  incomingDisplay: z.string().nullable().optional(),
  /** Номер и название пункта для окна конфликта. */
  item: z.object({ number: z.string(), title: z.string() }).optional(),
});
export type CommandConflict = z.infer<typeof CommandConflictSchema>;

export const ConflictDetailsSchema = z.object({
  authoritativeRevision: z.number().int().min(1),
  conflicts: z.array(CommandConflictSchema).min(1),
});
export type ConflictDetails = z.infer<typeof ConflictDetailsSchema>;
